import { Link } from "react-router-dom"
import { Logo } from "@/components/ui/Logo"
import { useTranslation } from "react-i18next"

export function LandingFooter() {
    const { t } = useTranslation('landing')

    return (
        <footer className="border-t py-12">
            {/* Gradient top border */}
            <div className="container mx-auto px-4">
                <div className="grid md:grid-cols-4 gap-8 mb-8">
                    <div>
                        <Logo />
                        <p className="text-sm text-muted-foreground mt-2">
                            {t('footer.tagline')}
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold mb-4">{t('footer.product')}</h3>
                        <ul className="space-y-2 text-sm text-muted-foreground">
                            <li>
                                <Link to="#features" className="hover:text-purple-500">
                                    {t('footer.links.features')}
                                </Link>
                            </li>
                            <li>
                                <Link to="#templates" className="hover:text-purple-500">
                                    {t('footer.links.templates')}
                                </Link>
                            </li>
                            <li>
                                <Link to="#how-it-works" className="hover:text-purple-500">
                                    {t('footer.links.howItWorks')}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-semibold mb-4">{t('footer.company')}</h3>
                        <ul className="space-y-2 text-sm text-muted-foreground">
                            <li>
                                <a href="#" className="hover:text-purple-500">
                                    {t('footer.links.about')}
                                </a>
                            </li>
                            <li>
                                <a href="#" className="hover:text-purple-500">
                                    {t('footer.links.blog')}
                                </a>
                            </li>
                            <li>
                                <a href="#" className="hover:text-purple-500">
                                    {t('footer.links.contact')}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-semibold mb-4">{t('footer.legal')}</h3>
                        <ul className="space-y-2 text-sm text-muted-foreground">
                            <li>
                                <a href="#" className="hover:text-purple-500">
                                    {t('footer.links.privacyPolicy')}
                                </a>
                            </li>
                            <li>
                                <a href="#" className="hover:text-purple-500">
                                    {t('footer.links.termsOfService')}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t pt-8 text-center text-sm text-muted-foreground">
                    <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
                </div>
            </div>
        </footer>
    )
}
